import { t } from "i18next";
import { PropsWithChildren } from "react";
import { Fragment } from "react/jsx-runtime";

import { colors } from "#app/theme/v1/colors";
import { ClusterCardChips } from "#modules/similarPart/view/clustering/ClusterCardChips";
import { ClusterCardCosts } from "#modules/similarPart/view/clustering/ClusterCardCosts";
import { ClusterCardFeatures } from "#modules/similarPart/view/clustering/ClusterCardFeatures";
import { ClusterCardQuantity } from "#modules/similarPart/view/clustering/ClusterCardQuantity";
import { Icon } from "#shared/icons/Icon";
import { Flex } from "#shared/view/components/Flex";
import { Text } from "#shared/view/components/Text";

export const ClusterCardData = ({
  quantity,
  children,
}: PropsWithChildren & {
  quantity: number | undefined | null;
}) => {
  if (!quantity) {
    return (
      <Flex gap="xs" justify={"center"} w={"100%"}>
        <Icon name="alertTriangle" color={colors.red[5]} size={14} />
        <Text c={colors.red[5]}>{t("similarPart.clustering.noQuantity")}</Text>
      </Flex>
    );
  }

  return <Fragment>{children}</Fragment>;
};

ClusterCardData.Costs = ClusterCardCosts;
ClusterCardData.Chips = ClusterCardChips;
ClusterCardData.Features = ClusterCardFeatures;
ClusterCardData.Quantity = ClusterCardQuantity;
